import {onScopeDispose, ref} from 'vue'

export const useUndoRemoval = (onRemove: () => void, onPending: (pending: boolean) => void, duration: () => number) => {
  const pending = ref(false)
  const time = ref(0)
  let timeout: ReturnType<typeof setTimeout> | undefined
  let interval: ReturnType<typeof setInterval> | undefined
  const clearTimers = () => {clearTimeout(timeout); clearInterval(interval)}
  const start = () => {
    if (pending.value) return
    const configured = duration()
    const milliseconds = Number.isFinite(configured) && configured > 0 ? configured : 5000
    pending.value = true
    time.value = Math.ceil(milliseconds / 1000)
    onPending(true)
    interval = setInterval(() => {time.value = Math.max(0, time.value - 1)}, 1000)
    timeout = setTimeout(() => {clearTimers(); time.value = 0; onRemove()}, milliseconds)
  }
  const revert = () => {
    clearTimers()
    pending.value = false
    time.value = 0
    onPending(false)
  }
  onScopeDispose(clearTimers)
  return {pending, time, start, revert}
}
